import component from '.';
import { DEFAULT_EDITORS_FIT_DATA_ORDER } from "../../../../lib/utils/consts";
import { vueDeepAssign } from "../../../../lib/utils/vue";

/** @type {(schema: import('@tencent/data-schema-core').PatchedDataSchema) => any} */
const schema2props = dataSchema => {
  var _dataSchema$validatio, _dataSchema$validatio2;
  return {
    max: (_dataSchema$validatio = dataSchema.validation) === null || _dataSchema$validatio === void 0 ? void 0 : _dataSchema$validatio.maximum,
    min: (_dataSchema$validatio2 = dataSchema.validation) === null || _dataSchema$validatio2 === void 0 ? void 0 : _dataSchema$validatio2.minimum,
    step: '1'
  };
};

/** @type {UICore.ComponentMeta} */
const NumberInputComponentMeta = {
  id: 'numberInput',
  name: '数字输入框',
  icon: 'https://vfiles.gtimg.cn/wuji_dashboard/xy/rainbow/icon-number-input_1636364610889.png',
  category: '编辑框',
  component,
  bindings: [{
    id: 'v-model',
    main: true,
    required: true,
    prop: 'value',
    event: 'change',
    checkData: s => s.type === 'number' || s.type === 'integer',
    onBind({
      dataSchema
    }, layout) {
      vueDeepAssign(layout, {
        props: schema2props(dataSchema)
      });
    }
  }],
  isFormEditor: true,
  propsSchema: {
    type: 'object',
    fields: [{
      id: 'value',
      type: 'number'
    }, {
      id: 'readonly',
      type: 'boolean',
      title: '只读'
    }, {
      id: 'required',
      type: 'boolean',
      title: '必填'
    }, {
      id: 'max',
      title: '最大值',
      type: 'number',
      default: +1e8
    }, {
      id: 'min',
      title: '最小值',
      type: 'number',
      default: -1e8
    }, {
      id: 'step',
      title: '步长',
      description: '输入的数值必须是 X 的倍数',
      type: 'string',
      default: '1'
    }]
  },
  events: [{
    id: 'change',
    name: '修改',
    desc: '输入内容变化时。 `$event` 为新的内容',
    arguments: [{
      type: 'number',
      description: '修改后的值'
    }]
  }],
  fitData({
    dataSchema,
    dataPath
  }) {
    if (dataSchema.type !== 'number' && dataSchema.type !== 'integer') return null;
    return {
      type: 'editor',
      order: DEFAULT_EDITORS_FIT_DATA_ORDER,
      layout: {
        type: 'numberInput',
        bindings: {
          'v-model': dataPath
        },
        props: schema2props(dataSchema)
      }
    };
  }
};
export default NumberInputComponentMeta;
//# sourceMappingURL=meta.js.map
